import { all, takeEvery, put, call } from 'redux-saga/effects';
import * as countryService from '../../services/country';
import actions from './actions';

export function* allCountries() {
  yield put({
    type: 'country/SET_STATE',
    payload: {
      loadingAll: true,
    },
  });

  const response = yield call(countryService.all);

  if (response && response.status === 200) {
    const { data } = response;

    const countries = data.data;
    
    const path = window.location.pathname;
    const pathMatch = path.match(/^\/([a-z]{2})\//);
    const urlLocale = pathMatch ? pathMatch[1] : null;
    const validLocales = ['hr', 'rs', 'ba'];

    let desiredLocale = 'hr';
    if (urlLocale && validLocales.includes(urlLocale)) {
      desiredLocale = urlLocale;
    } else if (path === '/' || path === '') {
      desiredLocale = 'hr';
    } else {
      const storedLocale = localStorage.getItem('translation');
      if (storedLocale && validLocales.includes(storedLocale)) {
        desiredLocale = storedLocale;
      }
    }

    let country = countries.find(c => c?.language?.code === desiredLocale);
    if (!country) {
      let countryId = 2;
      if (desiredLocale === 'rs') countryId = 1;
      if (desiredLocale === 'ba') countryId = 3;
      country = countries.find(c => c.id === countryId);
    }
    if (!country) {
      country = (Array.isArray(countries) && countries.length > 0) ? countries[0] : null;
    }

    if (country && country.language) {
      localStorage.setItem('translation', country.language.code);
    }

    yield put({
      type: 'country/SET_STATE',
      payload: {
        all: data.data,
        selected: country
      },
    });

    yield put({
      type: 'languages/SET_STATE',
      payload: {
        selected: country ? country.language : null
      },
    })
  }

  yield put({
    type: 'country/SET_STATE',
    payload: {
      loadingAll: false,
    },
  })
}

export function* selected({ payload }) {
  yield put({
    type: 'country/SET_STATE',
    payload: {
      selected: payload.country
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ALL, allCountries),
    takeEvery(actions.SELECT, selected),
    allCountries()
  ])
}
